<template>
  <div class="px-2 mx-auto flex justify-center items-center w-full">
    <div v-for="(_step, n) in steps" :key="n"
      class="items-center justify-center flex"
      :class="n === steps.length - 1 ? 'shrink' : 'grow'">
      <div class="flex items-center w-full">
        <div
          class="rounded-full h-8 w-8 flex items-center justify-center transition-all shrink-0 stepper-dot"
          :class="{
            'stepper-dot-active': n === currentStep,
            'stepper-dot-done': n < currentStep,
            'stepper-dot-pending': n > currentStep
          }">
          <CheckIcon v-if="n < currentStep" class="h-4 w-4 text-white stroke-2" />
          <span v-else class="text-xs font-semibold"
            :class="{
              'stepper-num-active': n === currentStep,
              'stepper-num-pending': n > currentStep
            }">
            {{ String(n + 1).padStart(2, '0') }}
          </span>
        </div>

        <div v-if="n < steps.length - 1"
          class="h-0.5 w-auto grow transition-all mx-1.5 rounded-full stepper-line"
          :class="{
            'stepper-line-done': n < currentStep,
            'stepper-line-pending': n >= currentStep
          }">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/24/outline'

defineProps<{
  steps: string[]
  currentStep: number
}>()
</script>

<style scoped>
/* ── Light mode ── */
.stepper-dot-active {
  border: 2px solid #06C8FF;
  background: rgba(6, 200, 255, 0.06);
  box-shadow: 0 0 0 3px rgba(6, 200, 255, 0.10);
}
.stepper-dot-done {
  border: 2px solid #06C8FF;
  background: linear-gradient(135deg, #06C8FF 0%, #009FE3 100%);
}
.stepper-dot-pending {
  border: 2px solid rgba(0, 0, 0, 0.10);
  background: var(--background);
}
.stepper-num-active {
  color: #06C8FF;
}
.stepper-num-pending {
  color: var(--muted-foreground);
}
.stepper-line-done {
  background: #06C8FF;
}
.stepper-line-pending {
  background: rgba(0, 0, 0, 0.08);
}

/* ── Dark mode ── */
:is(.dark *).stepper-dot-active {
  border-color: #06C8FF;
  background: rgba(6, 200, 255, 0.10);
  box-shadow: 0 0 0 3px rgba(6, 200, 255, 0.08);
}
:is(.dark *).stepper-dot-done {
  border-color: #06C8FF;
}
:is(.dark *).stepper-dot-pending {
  border-color: rgba(255, 255, 255, 0.10);
}
:is(.dark *).stepper-line-done {
  background: #06C8FF;
}
:is(.dark *).stepper-line-pending {
  background: rgba(255, 255, 255, 0.08);
}
</style>
